/* eslint-disable jsx-a11y/label-has-associated-control */

import React from "react";
import { showFormattedDate } from "../../../../../../../../../Utils";
import { useContext } from "../../../context";

export function EventDate() {
  const { appointment } = useContext();

  return (
    <div className="detail-row">
      <label>Event Date:</label>
      <span>{showFormattedDate(appointment.outOfOffice.date)}</span>
    </div>
  );
}
